import CampaignIcon from "@mui/icons-material/Campaign";
import { HEALTHCARE_CAMPAIGNS, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListHealthcareCampaign from "./List";
import CreateHealthcareCampaign from "./Create";
import EditHealthcareCampaign from "./Edit";
import ShowHealthcareCampaign from "./Show";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: SpecialistServicePath + HEALTHCARE_CAMPAIGNS,
  title: "Кампании за здравни грижи",
  list: <ListHealthcareCampaign />,
  show: <ShowHealthcareCampaign />,
  create: <CreateHealthcareCampaign />,
  edit: <EditHealthcareCampaign />,
  permission: permissions.canPreviewHealthcareCampaigns,
  showPermission: permissions.canPreviewHealthcareCampaigns,
  createPermission: permissions.canManageHealthcareCampaigns,
  editPermission: permissions.canManageHealthcareCampaigns,
};
